import { forwardRef, type Ref, type SVGProps } from "react";
const IconFullScreenOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M28 2H4a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2m0 26H4V4h24z"
    />
    <path
      fill="currentColor"
      d="M13.71 13.71a1 1 0 0 1-1.42 0L8 9.41V12a1 1 0 0 1-2 0V7a1 1 0 0 1 .08-.38 1 1 0 0 1 .54-.54A1 1 0 0 1 7 6h5a1 1 0 0 1 0 2H9.41l4.3 4.29a1 1 0 0 1 0 1.42m0 6L9.41 24H12a1 1 0 0 1 0 2H7a1 1 0 0 1-.38-.08 1 1 0 0 1-.54-.54A1 1 0 0 1 6 25v-5a1 1 0 0 1 2 0v2.59l4.29-4.3a1 1 0 0 1 1.42 1.42M26 20v5a1 1 0 0 1-.08.38 1 1 0 0 1-.54.54A1 1 0 0 1 25 26h-5a1 1 0 0 1 0-2h2.59l-4.3-4.29a1 1 0 0 1 1.42-1.42l4.29 4.3V20a1 1 0 0 1 2 0m0-13v5a1 1 0 0 1-2 0V9.41l-4.29 4.3a1 1 0 0 1-1.42 0 1 1 0 0 1 0-1.42L22.59 8H20a1 1 0 0 1 0-2h5a1 1 0 0 1 .38.08 1 1 0 0 1 .54.54A1 1 0 0 1 26 7"
    />
  </svg>
);
const ForwardRef = forwardRef(IconFullScreenOutlineSVG);
ForwardRef.displayName = "IconFullScreenOutline";
export { ForwardRef as IconFullScreenOutline };
